
import { Table, Button } from "reactstrap";
import * as XLSX from "xlsx";
import devuelveDependenciaConstultada from "../tools/devuelveDependencia";
import regresaBienFecha from "../tools/regresaBienFecha";
import devuelveSede from "../tools/devuelveSede";

function ModuloDevuelveListaExpedientesDependencia(props) {
  const dependencias = devuelveDependenciaConstultada() || [];
  const sedes = devuelveSede() || [];

  const nombreDependencia = (id) => {
    return (
      dependencias.find(
        (categoria) => String(categoria.id) === String(id)
      )?.descripcion || "-"
    );
  };

  const nombreSede = (id) => {
    return (
      sedes.find(
        (categoria) => String(categoria.id) === String(id)
      )?.descripcion || "-"
    );
  };

  // Normalizamos la lista sin modificar los datos originales.
  const expedientes = (Array.isArray(props.cosas)
    ? props.cosas
    : []
  )
    .map((cosas) => (Array.isArray(cosas) ? cosas[0] : cosas))
    .filter(Boolean);

  const obtenerDependenciaInicio = (expediente) => {
    return `${nombreDependencia(expediente.dependenciaID)} (${nombreSede(
      expediente.sedeID
    )})`;
  };

  const obtenerProcedencia = (expediente) => {
    if (expediente.ProvinoDesdeDestino === "Z") {
      return "Salida en tránsito desde este destino";
    }

    return `${nombreDependencia(
      expediente.ProvinoDesdeDestino
    )} (${nombreSede(expediente.ProvinoDesdeSede)})`;
  };

  // ==================================================
  // EXPORTAR LA LISTA ACTUAL A EXCEL
  // ==================================================
  const exportarExcel = () => {
    if (expedientes.length === 0) {
      return;
    }

    const datosExcel = expedientes.map((expediente, index) => ({
      "#": index + 1,
      "ID Exp": expediente.id ?? "",
      "Fecha": expediente.createdAt
        ? regresaBienFecha(expediente.createdAt)
        : "-",
      "Iniciador": expediente.iniciador ?? "",
      "Concepto": expediente.concepto ?? "",
      "Depen. Inicio": obtenerDependenciaInicio(expediente),
      "Provino desde": obtenerProcedencia(expediente),
      "Desde Fecha": expediente.FechaUltimoMovimiento || "-",
    }));

    const hoja = XLSX.utils.json_to_sheet(datosExcel);

    // Ancho de columnas
    hoja["!cols"] = [
      { wch: 7 },
      { wch: 13 },
      { wch: 17 },
      { wch: 32 },
      { wch: 65 },
      { wch: 42 },
      { wch: 42 },
      { wch: 22 },
    ];

    // Filtros automáticos en encabezados
    hoja["!autofilter"] = {
      ref: hoja["!ref"],
    };

    const libro = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      libro,
      hoja,
      "Expedientes en dependencia"
    );

    const fecha = new Date();
    const fechaArchivo = [
      fecha.getFullYear(),
      String(fecha.getMonth() + 1).padStart(2, "0"),
      String(fecha.getDate()).padStart(2, "0"),
    ].join("-");

    XLSX.writeFile(
      libro,
      `SIGEDI_Expedientes_Dependencia_${fechaArchivo}.xlsx`
    );
  };

  return (
    <div>
      {/* ENCABEZADO Y EXPORTACIÓN */}
      <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ gap: "10px", flexWrap: "wrap" }}
      >
        <div>
          <strong>Expedientes en dependencia</strong>
          <div style={{ fontSize: "12px", color: "#666" }}>
            Total: {expedientes.length} expedientes
          </div>
        </div>

        <Button
          color="success"
          size="sm"
          onClick={exportarExcel}
          disabled={expedientes.length === 0}
        >
          Exportar a Excel ({expedientes.length})
        </Button>
      </div>

      {/* TABLA ORIGINAL */}
      <Table className="table-primary" bordered size="sm">
        <thead>
          <tr style={{ backgroundColor: "#cccccc", fontSize: "10px" }}>
            <th style={{ padding: "8px" }}>#</th>
            <th style={{ padding: "10px" }}>ID Exp</th>
            <th style={{ padding: "10px" }}>Fecha</th>
            <th style={{ padding: "10px" }}>Iniciador</th>
            <th style={{ padding: "10px" }}>Concepto</th>
            <th style={{ padding: "10px" }}>Depen. Inicio</th>
            <th style={{ padding: "10px" }}>Provino desde</th>
            <th style={{ padding: "10px" }}>Desde Fecha</th>
          </tr>
        </thead>

        <tbody>
          {(Array.isArray(props.cosas) ? props.cosas : []).map(
            (cosas, index) => {
              const expediente = Array.isArray(cosas)
                ? cosas[0]
                : cosas;

              if (!expediente) return null;

              return (
                <tr
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                  key={expediente.id || index}
                  onClick={() => props.myID(cosas)}
                >
                  <th scope="row" style={{ padding: "10px" }}>
                    {expedientes.indexOf(expediente) + 1}
                  </th>

                  <th scope="row">{expediente.id}</th>

                  <th style={{ padding: "10px" }}>
                    {regresaBienFecha(expediente.createdAt)}
                  </th>

                  <th style={{ padding: "10px" }}>
                    {expediente.iniciador}
                  </th>

                  <th style={{ padding: "10px" }}>
                    {expediente.concepto}
                  </th>

                  <th style={{ padding: "10px" }}>
                    {obtenerDependenciaInicio(expediente)}
                  </th>

                  <th style={{ padding: "10px" }}>
                    {obtenerProcedencia(expediente)}
                  </th>

                  <th style={{ padding: "10px" }}>
                    {expediente.FechaUltimoMovimiento || "-"}
                  </th>
                </tr>
              );
            }
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default ModuloDevuelveListaExpedientesDependencia;
